// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicator":"styles_loadingIndicator__2YZWk","rotation_animation":"styles_rotation_animation__33Loq"};